import { render, staticRenderFns } from "./EcommerceClientOnboarded.vue?vue&type=template&id=3915ad3c&"
import script from "./EcommerceClientOnboarded.vue?vue&type=script&lang=js&"
export * from "./EcommerceClientOnboarded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports